import React, { useState, useEffect } from "react";
import styles from "./styles.css";
import Arrow from "./images/arrow-upward.svg";
import { NUMBER } from "../../../constants/app-constants";

const CdpGoToTop = () => {
    const [isVisible, setIsVisible] = useState(false);

    const handleScrollUp = () => {
        if (typeof window !== "undefined") {window.scrollTo({ left: 0, top: 0, behavior: "smooth" });}
    };

    const toggleVisibility = () => {
        if (window.pageYOffset > NUMBER.FOUR_THOUSAND) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", toggleVisibility);
        return () => {
            window.removeEventListener("scroll", toggleVisibility);
        };
    }, []);

    if (!isVisible) {
        return null;
    }
    return (
        <div onClick={handleScrollUp} styleName={"styles.wrapper"}>
            <img src={Arrow} alt="Go to top arrow"/>
            <p styleName={"styles.gotoTop"}>GO TO TOP</p>
        </div>
    );
};

export default CdpGoToTop;
